var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"questionDetailBox"},[_c('h5',[_vm._v(_vm._s(_vm.question.title))]),_c('p',[_vm._v(_vm._s(_vm.question.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }